import { getTyrisIcon } from '../components/ui/tyris-icon';

export interface WorkoutSet {
  setNumber: number;
  weight: number;
  reps: number;
  rir?: number | null;
  exercise: { id: string; name: string };
}

export interface WorkoutSession {
  id: string;
  date: string;
  notes?: string;
  sets: WorkoutSet[];
}

function escapeHtml(value: string | number | null | undefined): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderWorkoutSessionCard(
  session: WorkoutSession,
  options?: {
    showDeleteButton?: boolean;
    isDeletingId?: string;
    showHeader?: boolean;
  }
): string {
  const date = new Date(session.date).toLocaleDateString('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const grouped: Record<string, WorkoutSet[]> = {};
  for (const s of session.sets) {
    if (!grouped[s.exercise.name]) {
      grouped[s.exercise.name] = [];
    }
    grouped[s.exercise.name].push(s);
  }

  const deleteButtonHtml = options?.showDeleteButton
    ? `
      <button class="btn btn-outline btn-sm btn-delete-workout" 
              data-session-id="${session.id}" 
              ${options.isDeletingId === session.id ? 'disabled' : ''} 
              style="border-color:rgba(239,68,68,0.3);color:#ef4444;padding:0.35rem 0.75rem;font-size:0.8rem;width:auto;margin-left:0.5rem;flex-shrink:0;">
        ${options.isDeletingId === session.id ? `${getTyrisIcon('en-curso', { size: 14 })} Eliminando...` : `${getTyrisIcon('basura', { size: 14 })} Eliminar`}
      </button>
    `
    : '';

  const showHeader = options?.showHeader !== false;

  return `
    <div class="card-glass" style="padding:1.5rem;">
      ${showHeader ? `
      <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:nowrap;gap:0.5rem;margin-bottom:1rem;">
        <div style="min-width:0;flex:1;">
          <div style="font-weight:700;font-size:1.05rem;word-break:break-word;">${date}</div>
          ${session.notes ? `<div style="color:var(--text-muted);font-size:0.85rem;margin-top:0.25rem;word-break:break-word;">${escapeHtml(session.notes)}</div>` : ''}
        </div>
        <div style="display:flex;align-items:center;gap:0.5rem;flex-shrink:0;">
          <span style="background:rgba(0,0,0,0.25);border:1px solid var(--border-metallic);border-radius:var(--radius-sm);padding:0.25rem 0.75rem;font-size:0.8rem;color:var(--text-muted);white-space:nowrap;">
            ${session.sets.length} series · ${Object.keys(grouped).length} ejercicios
          </span>
          ${deleteButtonHtml}
        </div>
      </div>
      ` : ''}
      <div style="display:flex;flex-direction:column;gap:0.75rem;">
        ${Object.entries(grouped)
          .map(
            ([name, sets]) => `
          <div>
            <div style="font-size:0.85rem;font-weight:600;color:var(--color-primary);margin-bottom:0.35rem;">${escapeHtml(name)}</div>
            <div style="display:flex;flex-wrap:wrap;gap:0.4rem;">
              ${sets
                .map(
                  (s) => `
                <span style="background:rgba(0,0,0,0.2);border:1px solid var(--border-metallic);border-radius:var(--radius-sm);padding:0.25rem 0.6rem;font-size:0.82rem;white-space:nowrap;">
                  S${escapeHtml(s.setNumber)}: <strong>${escapeHtml(s.weight)}kg × ${escapeHtml(s.reps)}</strong>${s.rir != null ? ` <span style="color:var(--text-muted);">· RIR ${escapeHtml(s.rir)}</span>` : ''}
                </span>
              `
                )
                .join('')}
            </div>
          </div>
        `
          )
          .join('')}
      </div>
    </div>
  `;
}
